import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ThemeSelector from '@/components/ThemeSelector.vue';
import Navbar from './components/Navbar.vue';
import AppFooter from './components/AppFooter.vue';
import {onMounted, ref} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const loading = ref(true);

onMounted(() => {
  setTimeout(() => {
    loading.value = false;
  }, 50);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar),
    _createVNode(ThemeSelector, { "is-in-app": "" }),
    _createElementVNode("div", {
      class: _normalizeClass(["spinner-container", {'d-none': !loading.value}])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([{'d-none': loading.value, 'app--fade-in': !loading.value}])
    }, [
      _createVNode(_component_router_view)
    ], 2),
    _createVNode(AppFooter)
  ], 64))
}
}

})